module.exports = __webpack_public_path__ + "static/img/a.ac91fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a.png
// module id = yiGj
// module chunks = 1